import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DragHandleHoverContainerContext = /*#__PURE__*/createContext({
  renderGripOnHover: false
});
export const DragHandleHoverContainerProvider = ({
  renderGripOnHover,
  children
}) => {
  const value = useMemo(() => ({
    renderGripOnHover
  }), [renderGripOnHover]);
  return /*#__PURE__*/_jsx(DragHandleHoverContainerContext.Provider, {
    value: value,
    children: children
  });
};
export const useDragHandleHoverContainerContext = () => {
  return useContext(DragHandleHoverContainerContext);
};